// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { DemandOut } from './demandOut.zod.ts';

export const DemandListOut = zod.object({
  "items": zod.array(DemandOut),
  "page": zod.int(),
  "page_size": zod.int(),
  "total": zod.int()
});

export type DemandListOut = zod.input<typeof DemandListOut>;
export type DemandListOutOutput = zod.output<typeof DemandListOut>;
